export const getSortedWebinars = webinarList => {
  const sortedHistory = webinarList?.sort((a, b) => {
    return new Date(b.date) - new Date(a.date)
  })

  return sortedHistory
}

export const guessLatestFromProps = (sortedHistory, selectedIndex) => {
  const arrayIndex = selectedIndex ? parseInt(selectedIndex) : 0 //props.properties.arrayIndex;
  const latest = sortedHistory?.length > arrayIndex ? sortedHistory[arrayIndex] : null

  return latest
}
